// extracted by css-extract-rspack-plugin
export default {"installableAppAccessRadioButtonsContainer":"installableAppAccessRadioButtonsContainer__zxU7b","installableAppAccessLabelContainer":"installableAppAccessLabelContainer__o9wyj"};